/* eslint-disable no-console */

const DEBUG = process.env.NODE_ENV === 'development';

const authRefresh = async (config) => {
    if (DEBUG) {
        console.info('✉️ ', config);
    }
    return config;
};

export default authRefresh;
